import React from 'react'

export default function WeldersEngineerOne(props) {
  return <div className='App-paper'>WeldersEngineerOne</div>
}